import { render, staticRenderFns } from "./BusinessAccountSettings.vue?vue&type=template&id=e5474d94"
import script from "./BusinessAccountSettings.vue?vue&type=script&lang=js"
export * from "./BusinessAccountSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports